import { Component, HostListener, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FuelService } from 'src/app/services/fuel.service';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { Fuel } from 'src/app/shared/models/Fuel';
import { Tank } from 'src/app/shared/models/Tank';
import { User } from 'src/app/shared/models/User';
import swal from 'sweetalert';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-list-tank-page',
  templateUrl: './list-tank-page.component.html',
  styleUrls: ['./list-tank-page.component.css']
})
export class ListTankPageComponent implements OnInit {
  user!: User;
  tanks: Tank[] = [];
  fuelService: FuelService;
  selectedTank: Tank = {} as Tank;
  encoderPassword: string = '';
  
  @ViewChild('encoderModal') encoderModalRef!: TemplateRef<any>;
  modalRef: NgbModalRef | null = null;

  constructor(private tankService: TankService, fuelService: FuelService, private userService: UserService, private modalService: NgbModal) {

    this.fuelService = fuelService;
  }

  ngOnInit() {
    this.initUserData();
  }

  /*listTanks() {
    this.tankService.getAll().subscribe(data => {
      console.log(data);
      this.tanks = data;
    }, error => {
      console.log(error);
    })

  }*/


  private initUserData() {
    this.userService.userObservable.subscribe((newUser) => {
      this.user = newUser;
      this.initTankList();
    });
  }


  private initTankList() {

    if (this.user.role == "superadmin") {
      this.tankService.getAll().subscribe((tankList: Tank[]) => {
        this.tanks = tankList;
      })

    }
    /*else if (this.user.role === "admin" || this.user.role === "cargador") {
      this.tankService.getTankByUser(this.user.id).subscribe((tankList: Tank[]) => {
        const tanksByUser = tankList.filter(tank => tank.administrators.includes(this.user.id));
        this.tanks = tanksByUser.filter(tank => this.user.tanks.includes(tank.id));
      });
    }*/


    /*else if (this.user.role === "admin" || this.user.role === "cargador") {
      this.userService.getUser(this.user.id).subscribe((admin: User) => {
        this.tankService.getTank(admin.tanks[0]).subscribe((tank: Tank) => {
          this.tanks.push(tank);
        });
      });*/


    else if (this.user.role === "admin") {
      this.tankService.getTank(this.user.tankId).subscribe((tank: Tank) => {
        this.tanks.push(tank);
      });

    } else {
        this.tankService.getTank(this.user.tankId).subscribe((tank: Tank) => {
        this.tanks.push(tank);

      });
    }


  }

    openEncoderModal(tank: Tank) {
    this.selectedTank = { ...tank };
    this.modalRef = this.modalService.open(this.encoderModalRef);
  }

  updateEncoderSpeed() {
    // console.log("ID:", this.selectedTank.id);
    // console.log("encoderSpeed:", this.selectedTank.encoderSpeed);
    // console.log("password:", this.encoderPassword);

    this.tankService.updateEncoderSpeed(
      this.selectedTank.id,
      this.selectedTank.encoderSpeed,
      this.encoderPassword
    ).subscribe({
      next: (updatedTank) => {

        swal("Éxito", "Contador de pulsos actualizado correctamente", "success");
        this.selectedTank = updatedTank;
        if (this.modalRef) {
          this.modalRef.close();
        }
      },
      error: (err) => {

        swal("Error", err.error.message || "No se pudo actualizar el encoder", "error");
      }
    });
  }

  deleteTank(id: any) {

    swal({
      title: "Estas Seguro?",
      text: "Esta accion no se puede deshacer",
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {

          if (this.tankService.deleteTank(id).subscribe(data => {
            this.initTankList();
          }, error => {
            console.log(error);
          })) {
            return;
          }

          swal("Tanque Eliminado", {
            icon: "success",
          });
        } else {
          swal("Accion cancelada");
          return;
        }
      });


  }



  resetFilter(id: any) {
    swal({
      title: "Seguro?",
      text: "Estas a punto de reiniciar el filtro",
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.tankService.getTank(id).subscribe(
          (tank) => {
            tank.amountFilter = 0; // Utiliza el operador de asignación (=) para establecer el valor
            this.tankService.editTank(tank.id, tank).subscribe(
              () => {
                this.initTankList();
                swal("Filtro Reiniciado", { icon: "success" });
              },
              (error) => {
                console.log(error);
              }
            );
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        swal("Accion cancelada");
      }
    });
  }


  isScreenBelow900(): boolean {
    return window.innerWidth < 900;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {

  }


}
